import { Base } from "../../framework/base";
import { IFileAttachment, FileAttachment } from "../common/fileAttachment";

export interface IAttachments {
    attachments: IFileAttachment[];
}

export class Attachments implements IAttachments {
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IAttachments);
    constructor(obj?: any) {
        this.attachments = Base.getTypedArray<FileAttachment>(obj?.attachments, FileAttachment);
    }
}